"use client";

import { useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import Image from 'next/image';
import { google } from '@/utils/image';

export default function GoogleOAuthButton({ onSuccess, onError }) {
    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                // Get user info from Google
                const userInfoResponse = await fetch(
                    'https://www.googleapis.com/oauth2/v3/userinfo',
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    }
                );

                const userInfo = await userInfoResponse.json();

                onSuccess({
                    provider: 'google',
                    providerId: userInfo.sub,
                    email: userInfo.email,
                    name: userInfo.name,
                    picture: userInfo.picture,
                });
            } catch (error) {
                console.error('Error getting Google user info:', error);
                onError(error);
            }
        },
        onError: (error) => {
            console.error('Google login failed:', error);
            onError(error);
        },
    });

    return (
        <button
            className="social-btn google"
            type="button"
            onClick={() => login()}
        >
            <Image src={google} alt="google" width={20} height={20} />
        </button>
    );
}
